import React, { useState, useEffect } from 'react';
import {
  TextField, Typography, Paper,
  Divider, Grid, Button, FormControl, InputLabel,
  Select, MenuItem,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ChipInput from 'material-ui-chip-input';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Actions from '../../actions';

const useStyles = makeStyles((theme) => {
  return {
    paper: {
      padding: 12,
      margin: 'auto',
      marginTop: 20,
      [theme.breakpoints.up('md')]: {
        width: '30%',
      },
      [theme.breakpoints.up('sm')]: {
        width: '50%',
      },
      [theme.breakpoints.down('sm')]: {
        width: '60%',
      },
    },
    fullPaper: {
      padding: 12,
      width: '100%',
    },
    input: {
      marginTop: 4,
      marginBottom: 7,
    },
  };
});

// const {
//     name,
//     recurringSessions,
//     recurringSessionsFrequency,
//     personalTherapyRegionId,
//     realPrice,
//     currency,
//     type,
//     discountedPrice,
//     appAccessMonths,
//     recurringSessionsFrequencyDays,
//   } = req.body;
//   let {
//     isPopular,
//     specials,
//     userUid,
//     recurringNumber,
//   } = req.body;

function Form(props) {
  const {
    items, updateOffer, createOffer, getOffers, closeDialog,
  } = props;
  const classes = useStyles();
  const [state, setState] = useState({
    name: '',
    type: '',
    currency: '',
    personalTherapyRegionId: '',
    recurringSessionsFrequency: '',
    realPrice: 0,
    discountedPrice: 0,
    discountedPriceInUSD: 0,
    appAccessMonths: 0,
    recurringNumber: 0,
    recurringSessions: 0,
    recurringSessionsFrequencyDays: 0,
    uid: '',
    specials: [],
    isPopular: false,
    isInitial: false,
  });
  useEffect(() => {
    if (items) {
      setState({
        _id: items._id,
        name: items.name || '',
        type: items.type || '',
        currency: items.currency || '',
        personalTherapyRegionId: items.personalTherapyRegionId || '',
        recurringSessionsFrequency: items.recurringSessionsFrequency || '',
        realPrice: items.realPrice || 0,
        discountedPrice: items.discountedPrice || 0,
        discountedPriceInUSD: items.discountedPriceInUSD || 0,
        appAccessMonths: items.appAccessMonths || 0,
        recurringNumber: items.recurringNumber || 0,
        recurringSessions: items.recurringSessions || 0,
        recurringSessionsFrequencyDays: items.recurringSessionsFrequencyDays || 0,
        uid: items.uid || '',
        specials: items.specials || [],
        isPopular: items.isPopular || false,
        isInitial: items.isInitial || false,
      });
    }
  }, [items]);
  const handleChange = (e) => { return setState({ ...state, [e.target.name]: e.target.value }); };
  const handleNumber = (e) => { return setState({ ...state, [e.target.name]: (e.target.value < 0 || e.target.value === '') ? 0 : e.target.value }); };
  const handleAddChip = (item) => {
    const data = state.specials;
    data.push(item);
    setState({ ...state, specials: data });
  };
  const handleDeleteChip = (item, index) => {
    const data = state.specials;
    data.splice(index, 1);
    setState({ ...state, specials: data });
  };

  const handleSubmit = () => {
    if (closeDialog) closeDialog();
    if (items) { updateOffer(state).then(() => { getOffers(); }); } else {
      createOffer({
        ...state,
        userUid: state.uid,
      }).then(() => { getOffers(); });
    }
  };
  return (
    <div>
      <Paper className={items ? classes.fullPaper : classes.paper}>
        <Typography variant="h4" styles={{ textAlign: 'center' }}>
          {items ? 'Edit Offer' : 'Create Offer'}
        </Typography>
        <Divider />
        <Grid container spacing={2}>
          <Grid item md={6} sm={12}>
            <TextField
              className={classes.input}
              fullWidth
              name="name"
              size="small"
              value={state.name}
              onChange={handleChange}
              label="Enter name"
              variant="outlined"
            />
          </Grid>
          <Grid item md={6} sm={12}>
            <TextField
              className={classes.input}
              fullWidth
              name="personalTherapyRegionId"
              size="small"
              value={state.personalTherapyRegionId}
              onChange={handleChange}
              label="Personal Therapy Region Id"
              variant="outlined"
            />
          </Grid>
          <Grid item md={6} sm={12}>
            <TextField
              className={classes.input}
              fullWidth
              name="currency"
              size="small"
              value={state.currency}
              onChange={handleChange}
              label="Currency"
              variant="outlined"
            />
          </Grid>
          <Grid item md={6} sm={12}>
            <TextField
              className={classes.input}
              fullWidth
              name="type"
              size="small"
              value={state.type}
              onChange={handleChange}
              label="Type"
              variant="outlined"
            />
          </Grid>
          <Grid item md={6} sm={12}>
            <TextField
              className={classes.input}
              fullWidth
              name="discountedPrice"
              size="small"
              value={state.discountedPrice}
              onChange={handleNumber}
              label="Discounted Price"
              variant="outlined"
              type="number"
            />
          </Grid>
          <Grid item md={6} sm={12}>
            <TextField
              className={classes.input}
              fullWidth
              name="discountedPriceInUSD"
              size="small"
              value={state.discountedPriceInUSD}
              onChange={handleNumber}
              label="Discounted Price in USD"
              variant="outlined"
              type="number"
            />
          </Grid>
          <Grid item md={6} sm={12}>
            <TextField
              className={classes.input}
              fullWidth
              name="realPrice"
              size="small"
              value={state.realPrice}
              onChange={handleNumber}
              label="Real Price"
              variant="outlined"
              type="number"
            />
          </Grid>
          <Grid item md={6} sm={12}>
            <TextField
              className={classes.input}
              fullWidth
              name="recurringSessionsFrequency"
              size="small"
              value={state.recurringSessionsFrequency}
              onChange={handleChange}
              label="Recurring Sessions Frequency"
              variant="outlined"
            />
          </Grid>
          <Grid item md={6} sm={12}>
            <TextField
              className={classes.input}
              fullWidth
              name="recurringSessionsFrequencyDays"
              size="small"
              value={state.recurringSessionsFrequencyDays}
              onChange={handleNumber}
              label="Recurring Sessions Frequency Days"
              variant="outlined"
              type="number"
            />
          </Grid>
          <Grid item md={6} sm={12}>
            <TextField
              className={classes.input}
              fullWidth
              name="recurringNumber"
              size="small"
              value={state.recurringNumber}
              onChange={handleNumber}
              label="Recurring Number"
              variant="outlined"
              type="number"
            />
          </Grid>
          <Grid item md={6} sm={12}>
            <TextField
              className={classes.input}
              fullWidth
              name="uid"
              size="small"
              value={state.uid}
              onChange={handleChange}
              label="User Uid"
              variant="outlined"
            />
          </Grid>
          <Grid item md={6} sm={12}>
            <TextField
              className={classes.input}
              fullWidth
              name="recurringSessions"
              size="small"
              value={state.recurringSessions}
              onChange={handleNumber}
              label="Recurring Sessions"
              variant="outlined"
              type="number"
            />
          </Grid>
          <Grid item md={6} sm={12}>
            <TextField
              className={classes.input}
              fullWidth
              name="appAccessMonths"
              size="small"
              value={state.appAccessMonths}
              onChange={handleNumber}
              label="App Access Months"
              variant="outlined"
              type="number"
            />
          </Grid>
          <Grid item md={6} sm={12}>
            <ChipInput
              variant="outlined"
              fullWidth
              allowDuplicates
              label="Specials"
              helperText="Separate items with Enter"
              className={classes.input}
              value={state.specials}
              onAdd={(chip) => { return handleAddChip(chip); }}
              onDelete={(chip, index) => { return handleDeleteChip(chip, index); }}
            />
          </Grid>
          <Grid item md={6} sm={12}>
            <FormControl
              fullWidth
              variant="outlined"
              className={classes.formControl}
            >
              <InputLabel id="demo-simple-select-label">Is Popular</InputLabel>
              <Select
                name="isPopular"
                size="small"
                value={state.isPopular}
                onChange={handleChange}
                label="Is Popular"
              >
                <MenuItem value>Yes</MenuItem>
                <MenuItem value={false}>No</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item container md={12} sm={12} xs={12}>
            <Grid item md={6} sm={12} style={{ paddingRight: 8 }}>
              <FormControl
                fullWidth
                variant="outlined"
                className={classes.formControl}
              >
                <InputLabel id="demo-simple-select-label">Is Initial</InputLabel>
                <Select
                  name="isInitial"
                  size="small"
                  value={state.isInitial}
                  onChange={handleChange}
                  label="Is Initial"
                >
                  <MenuItem value>Yes</MenuItem>
                  <MenuItem value={false}>No</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Grid item md={12} sm={12}>
            <Button
              fullWidth
              variant="contained"
              onClick={handleSubmit}
              color="primary"
            >
              { items ? 'Edit Offer' : 'Create Offer'}
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

export default connect(null, mapDispatchToProps)(Form);
